import React from "react";

import type { ItemModelType, WorkspaceModelType } from "@stores/WorkspaceStore";
import type { RootStoreModel } from "@stores/RootStore";
import { DataSourceManager } from "@stores/dataSources/DataSourceManager";


import {createCluster} from "../item/createCluster";
import {createItem} from "../item/createItem";
import {CrudServices} from "../../platform/services/types/ServiceDependencies";


import {logErrorToSentry} from "../../utils/errors/logErrorToSentry";
import {AppState} from "@stores/AppState";


export const handleCreateCluster = (
    services: CrudServices,
    workspace: WorkspaceModelType,
    appState: AppState,
    item: ItemModelType
) => (event: React.MouseEvent<HTMLElement>) => {
    createCluster(services, {
        workspace: workspace,
        appState,
        parentId: item.id,
    }).catch(logErrorToSentry);
};

export const handleCreateItem = (
    services: CrudServices,
    workspace: WorkspaceModelType,
    appState: AppState,
    item: ItemModelType
) => (event: React.MouseEvent<HTMLElement>) => {
    createItem(services, {
        workspace: workspace,
        appState,
        parentId: item.id,
    }).catch(logErrorToSentry);
};
